
import Vue from "vue";
import data from "@/datatables/categories/projects";
import datatable from "@/utils/datatable/components/datatable.vue";
export default Vue.extend({
  name: "consultutns-list",
  components:{
    datatable
  },
  data(){
    return {
        data
    }
  },
});
